import React, { useState ,useEffect,useMemo } from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import "./BookList.css";
import { jwtDecode } from 'jwt-decode';
import ArticleForm from './ArticleForm';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { arSD } from '@mui/x-data-grid/locales';
import { debounce } from 'lodash';



const Article = ( { article } ) => { // Assuming the prop is named 'articles' and is an array
    
    const existingTheme = useTheme();
    const [showArticleForm, setShowArticleForm] = useState(false);
    const [ selectedRow, setSelectedRow ] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    arSD.components.MuiDataGrid.defaultProps.localeText.noRowsLabel = 'لا توجد بحوث';
    // console.log(arSD);
    const theme = React.useMemo(
      () =>
        createTheme({}, arSD, existingTheme, {
          direction: 'rtl',
        }),
      [existingTheme],
    );
  
  
const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
         checkTokenExpiration();
   
            const handleResize = () => {
              // Update state only if size crosses a breakpoint (example)
              const newWidth = window.innerWidth;
              if ((newWidth > 500 && windowWidth <= 500) || (newWidth <= 500 && windowWidth > 500)) {
                setWindowWidth(newWidth);
              }
            };
          
            // Debounce the resize function
            const debouncedHandleResize = debounce(handleResize, 100);
          
            window.addEventListener('resize', debouncedHandleResize);
            return () => window.removeEventListener('resize', debouncedHandleResize);
          
    }, [windowWidth]);
  
      const checkTokenExpiration = () => {
        const token = localStorage.getItem('token');
        //console.log("token");
        //console.log(token);
        if (token) {
          const decodedToken = jwtDecode(token);
          const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
          //console.log("decodedToken");
          //console.log(decodedToken);
          if (decodedToken.exp < currentTime) {
            // Token has expired, clear it from local storage
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('username');
          }
        }else{
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('username');
        }
        const username = localStorage.getItem('username');
        setIsLoggedIn(!!username); // Check if username exists in localStorage
         
      };

      article.forEach((element,i) => {
        element.id = (i+1) ;
      });
      
      const columns = useMemo(() => [
        { field: 'id', headerName: 'الرقم',  headerAlign: 'center', width: windowWidth > 500 ? 100 : 70, disableColumnMenu: true },
        {
          field: 'article_name',
          headerName: 'عنوان البحث ',
          headerAlign: 'center',
          width: windowWidth > 500 ? 700 : 200, // adjusted width here for example
          disableColumnMenu: true,
          renderCell: (params) => (
            params.row.article_url && /^(http:\/\/|https:\/\/)/.test(params.row.article_url) ?
              <Link to={params.row.article_url} target="_blank" rel="noopener noreferrer" state={{ book: params.row }}>{params.value}</Link>
              : "غير متوفر"
          ),
        },
        { field: 'author_name', headerName: 'الباحث', headerAlign: 'center', width: windowWidth > 500 ? 250 : 150, disableColumnMenu: true },

        isLoggedIn && {
          field: 'actions',
          headerName: 'تحديث',
          headerAlign: 'center',
          width: 150,
          disableColumnMenu: true,
          renderCell: (params) => (
            <div className='form-buttons' style={{ width: "100px", margin: "0px" }}>
              <button onClick={() => updateArticle(params.row)}>تحديث</button>
            </div>
          )
        }
      ].filter(Boolean), [isLoggedIn, windowWidth]);
    

  function updateArticle(params) {
    const updatedParams = {...params, isUpdating: true};
    setSelectedRow(updatedParams); 
    setShowArticleForm(true);
    
  }
  //add getlabel options

  return (
    

    <ThemeProvider theme={theme}>
     
    {showArticleForm && (
      
         <ArticleForm ArticleForm={selectedRow}></ArticleForm>

    )}
    <div className='book-item flex flex-column flex-sb'>
      <Box sx={{
        height: 600,
        width: "100%",
        fontSize: '1rem',
        '@media (max-width:660px)': { // Responsive adjustments for mobile devices
          height: 650,
          width: 350,
        }
      }}>
        <DataGrid
                rows={article||[]}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                getRowId={(row) => row.article_id|| `${row.title}-${row.timestamp_create}`}
                disableSelectionOnClick
             
                sx={{
                    '.MuiDataGrid-columnHeaders': {
                    backgroundColor: 'rgba(235, 235, 235, 0.7)', // Light background for headers
                    fontSize: '1.5rem', // Default font size for headers
                    },
                    '.MuiDataGrid-cell': {
                    fontSize: '1rem', // Default font size for cells]
                    textAlign: 'center',
                    },
                    '.MuiDataGrid-columnsContainer' : {
                        position:  "relative !important"
                    },
                    '.MuiDataGrid-row': {
                    '&:hover': {
                        backgroundColor: 'rgba(220, 220, 220, 0.7)', // Hover effect for rows
                    }
                    },
                    '@media (min-width:600px)': { // Smaller font size for smaller screens
                    fontSize: '0.8rem',
                    },
                    '@media (min-width:650px)': { // Larger font size for screens wider than 650px
                    '.MuiDataGrid-columnHeaders, .MuiDataGrid-cell': {
                        fontSize: '2rem', // Increased font size for headers and cells
                    }
                    },
                }}
                />

      </Box>
    </div>
    </ThemeProvider>
  );
};

export default Article;